import Data from "./Data";
import './App.css';


const App=()=> {
  

  return (
  <div className="App">
    <Data />
  </div>
  );
}

export default App;
